import { styled } from 'dripsy';
import React from 'react';
import { View } from 'react-native';

import { BaseText } from '../common/BaseText';
import { IS_WEB } from '@utils';

const Container = styled(View)({
  alignItems: 'center',
  justifyContent: 'center',
});

const TopTextContainer = styled(BaseText)({
  pb: '$4',
});

const TopText = styled(BaseText)({
  variant: 'text.small',
  color: '$text300',
  textAlign: 'center',
});

const Title = styled(BaseText)({
  variant: IS_WEB ? 'text.xbig' : 'text.xxlarge',
  fontWeight: 'semi',
  color: '$heading900',
  textAlign: 'center',
});

const BottomTextContainer = styled(View)({
  pt: '$5',
});

const BottomText = styled(BaseText)({
  variant: 'text.small',
  color: '$text90',
  textAlign: 'center',
});

export interface ITitleViewProps {
  title: string;
  topText?: string | React.ReactNode;
  bottomText?: string | React.ReactNode;
}

export function TitleView({
  title,
  topText,
  bottomText,
}: ITitleViewProps) {
  const isTopTextShown = !!topText;
  const isBottomTextShown = !!bottomText;

  return (
    <Container>
      {isTopTextShown && (
        <TopTextContainer>
          <TopText>{topText}</TopText>
        </TopTextContainer>
      )}
      <Title>{title}</Title>
      {isBottomTextShown && (
        <BottomTextContainer>
          <BottomText>{bottomText}</BottomText>
        </BottomTextContainer>
      )}
    </Container>
  );
}
